import { createSagaAction } from '../../shared/sagas'
import { createReducer } from '../../shared/reducers'

// Constants
export const constants = {
  DRIVERLIST_REFRESH: createSagaAction('DRIVERLIST_REFRESH')
}

// Action Creators
export const actions = {
  driverListRefresh: () => ({ type: constants.DRIVERLIST_REFRESH.ACTION })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, { type, payload }) => {
  switch (type) {
    case constants.DRIVERLIST_REFRESH.SUCCESS:
      return { ...state, payload }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/driverActions.js